import { useEffect } from 'react';

export interface FloorPlanBackgroundImgProps {
  backgroundSrc?: string;
  handleBackgroundOnClick?: () => void;
  initialImageSrcWidth: number;
  setTableIconScale: (scale: number) => void;
  containerWidth: number;
  containerHeight?: number;
}

export const FloorPlanBackgroundImg = ({
  backgroundSrc,
  containerWidth,
  setTableIconScale,
  initialImageSrcWidth,
}: FloorPlanBackgroundImgProps) => {
  const areFloorPlanImageAndContainerReady =
    initialImageSrcWidth && containerWidth;

  useEffect(() => {
    if (areFloorPlanImageAndContainerReady) {
      setTableIconScale(containerWidth / initialImageSrcWidth);
    }
  }, [
    containerWidth,
    initialImageSrcWidth,
    areFloorPlanImageAndContainerReady,
    setTableIconScale,
  ]);

  if (!containerWidth) return null;

  return (
    <img
      width={containerWidth}
      height="auto"
      alt="restaurant floor plan"
      src={backgroundSrc}
    />
  );
};
